import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import PublicNav from "@/components/PublicNav";
import PublicFooter from "@/components/PublicFooter";
import usePageMeta from "@/hooks/usePageMeta";
import { Badge } from "@/components/ui/badge";
import { Calendar, MapPin } from "lucide-react";

export default function Events() {
  const [items, setItems] = useState([]);
  usePageMeta("Events & Open Houses", "Upcoming school open houses, workshops and admission events near you.");
  useEffect(() => { api.get("/events").then((r) => setItems(r.data)); }, []);
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <PublicNav />
      <div className="mx-auto max-w-7xl px-6 py-12 flex-1">
        <h1 className="text-4xl font-bold tracking-tight text-slate-900" data-testid="events-heading">Events</h1>
        <p className="text-slate-500 mt-2">Upcoming school events, open days, and workshops</p>
        <div className="mt-10 grid md:grid-cols-2 gap-6">
          {items.length === 0 && <div className="text-slate-500 col-span-2">No events yet.</div>}
          {items.map((e) => (
            <div key={e.id} className="flex gap-5 bg-white border border-slate-200 rounded-lg p-5 hover:shadow-md transition-shadow" data-testid={`event-card-${e.id}`}>
              {e.cover_image && <img src={e.cover_image} alt="" className="w-32 h-32 object-cover rounded" />}
              <div className="flex-1">
                <Badge variant="outline" className="border-blue-300 text-blue-700 mb-2"><Calendar className="w-3 h-3 mr-1" />{e.event_date}</Badge>
                <h3 className="text-lg font-bold text-slate-900">{e.title}</h3>
                {e.location && <div className="text-sm text-slate-500 flex items-center gap-1 mt-1"><MapPin className="w-3 h-3" />{e.location}</div>}
                <p className="text-sm text-slate-600 mt-2 line-clamp-3">{e.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <PublicFooter />
    </div>
  );
}
